import { createFontSizeCSS } from '@hellodarwin/core/lib/theme/global-style';
import { media } from '@hellodarwin/core/lib/theme/mixins/responsive';
import styled, { css, keyframes } from 'styled-components';
import { MessageRole } from '../../types/message.types';
const fadeIn = keyframes `
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;
const messageAppear = keyframes `
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;
const streamedChunkAppear = keyframes `
  from {
    opacity: 0;
    transform: translateY(6px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
`;
export const tableStyle = css `
  table {
    table-layout: auto;

    ${media.mobile `
      table-layout: fixed;
      width: 100%;
    `}

    border-collapse: collapse;
    border: 1px solid ${({ theme }) => theme.colors.grey_3};
    max-width: 100%;
    width: fit-content;
    border-radius: ${({ theme }) => theme.border_radius.sm};
    background: ${({ theme }) => theme.colors.white_1};
    display: block;
    overflow-x: auto;
    box-shadow: ${({ theme }) => theme.appearance.box_shadow};
    margin-block: ${({ theme }) => theme.spacing.lg}px;
    box-shadow: ${({ theme }) => theme.appearance.box_shadow};
    &::-webkit-scrollbar {
      height: ${({ theme }) => theme.spacing.sm}px;
    }
    caption {
      caption-side: top;
      padding: ${({ theme }) => theme.spacing.sm}px;
      text-align: left;
      ${createFontSizeCSS('subtitle2')}
      font-weight: ${({ theme }) => theme.fontWeights.semibold};
      color: ${({ theme }) => theme.colors.grey_2};
    }
    &::-webkit-scrollbar-thumb {
      background: ${({ theme }) => theme.colors.purple_1}EE;
      transition: background 400ms ease;
      border-radius: ${({ theme }) => theme.border_radius.full};

      cursor: pointer;
    }

    thead th {
      position: sticky;
      top: 0;
      z-index: 2;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: ${({ theme }) => theme.colors.purple_2};
    }
    th,
    td {
      vertical-align: top;
      text-align: left;
      min-width: 200px;
      padding-inline: ${({ theme }) => theme.spacing.lg}px;
      padding-block: ${({ theme }) => theme.spacing.md}px;
    }
    th {
      background: ${({ theme }) => theme.colors.beige_1};
      border-bottom: 1px solid ${({ theme }) => theme.colors.grey_3};
      border-right: 1px solid ${({ theme }) => theme.colors.grey_3};
      ${createFontSizeCSS('body2', true, 'bold')}
      white-space: nowrap;

      &:last-child {
        border-right: none;
      }
    }

    td {
      border-bottom: 1px solid ${({ theme }) => theme.colors.grey_4};
      border-right: 1px solid ${({ theme }) => theme.colors.grey_4};
      ${createFontSizeCSS('body2')}

      &:last-child {
        border-right: none;
      }
    }

    td:first-child,
    th:first-child {
      padding-left: ${({ theme }) => theme.spacing.lg}px;
    }
    td:last-child,
    th:last-child {
      padding-right: ${({ theme }) => theme.spacing.lg}px;
    }
    tr {
      &:nth-child(even) {
        background: ${({ theme }) => theme.colors.beige_3}AA;
      }
      &:hover {
        background-color: ${({ theme }) => theme.colors.beige_2};
      }
      &:last-child {
        td {
          border-bottom: none;
        }
      }
    }
  }
`;
export const AssistantTypographyStyling = css `
  h1 {
    ${createFontSizeCSS('h3', true, 'bold')}
    margin-top: ${({ theme }) => theme.spacing.xxl}px;
    margin-bottom: ${({ theme }) => theme.spacing.lg}px;
    &:where(hr + *) {
      margin-top: 0;
    }
  }

  h2 {
    ${createFontSizeCSS('h4', true, 'bold')}
    margin-top: ${({ theme }) => theme.spacing.xxl}px;
    margin-bottom: ${({ theme }) => theme.spacing.lg}px;
    &:where(hr + *) {
      margin-top: 0;
    }
  }

  h3 {
    ${createFontSizeCSS('h5', true, 'bold')}
    margin-top: ${({ theme }) => theme.spacing.xl}px;
    margin-bottom: ${({ theme }) => theme.spacing.md}px;
    &:where(hr + *) {
      margin-top: 0;
    }
  }

  h4 {
    ${createFontSizeCSS('h6', true, 'bold')}
    margin-top: ${({ theme }) => theme.spacing.xl}px;
    margin-bottom: ${({ theme }) => theme.spacing.md}px;
    &:where(hr + *) {
      margin-top: 0;
    }
  }

  h5 {
    ${createFontSizeCSS('subtitle1', true, 'bold')}
    margin-top: ${({ theme }) => theme.spacing.lg}px;
    margin-bottom: ${({ theme }) => theme.spacing.sm}px;
    &:where(hr + *) {
      margin-top: 0;
    }
  }

  h6 {
    ${createFontSizeCSS('subtitle2', true, 'bold')}
    margin-top: ${({ theme }) => theme.spacing.md}px;
    margin-bottom: ${({ theme }) => theme.spacing.sm}px;
    &:where(hr + *) {
      margin-top: 0;
    }
  }

  p {
    ${createFontSizeCSS('body1')}
    margin-block: ${({ theme }) => theme.spacing.sm}px;
  }

  ul,
  ol {
    ${createFontSizeCSS('body1')}
    margin-block-start: ${({ theme }) => theme.spacing.md}px;
    margin-block-end: ${({ theme }) => theme.spacing.md}px;
    padding-inline-start: ${({ theme }) => theme.spacing.lg}px;

    ul,
    ol {
      display: block;
      margin-block-start: 0;
      margin-block-end: ${({ theme }) => theme.spacing.sm}px;
    }
    li {
      margin-block: ${({ theme }) => theme.spacing.xs}px;
      padding-left: ${({ theme }) => theme.spacing.xs}px;
    }
  }
  hr {
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey_4};
    width: 100%;
    margin-block-start: ${({ theme }) => theme.spacing.lg}px;
    margin-block-end: ${({ theme }) => theme.spacing.lg}px;
  }
  strong {
    font-weight: ${({ theme }) => theme.fontWeights.semibold};
  }
  blockquote {
    ${createFontSizeCSS('body2')}
    margin-block: ${({ theme }) => theme.spacing.md}px;
    padding-inline-start: ${({ theme }) => theme.spacing.lg}px;
    border-width: 0;
    position: relative;
    padding-block: ${({ theme }) => theme.spacing.sm}px;
    &:after {
      background-color: ${({ theme }) => theme.colors.purple_1};
      border-radius: ${({ theme }) => theme.border_radius.xs};
      bottom: ${({ theme }) => theme.spacing.sm}px;
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: ${({ theme }) => theme.spacing.xs}px;

      height: 100%;
    }
  }
  pre {
    ${createFontSizeCSS('body3')}
    padding: ${({ theme }) => theme.spacing.xl}px;
    border: 1px solid ${({ theme }) => theme.colors.grey_4};
    border-radius: ${({ theme }) => theme.border_radius.sm};
    background: ${({ theme }) => theme.colors.beige_4};
  }
  ${tableStyle}
`;
export const MessageListContainer = styled.section `
  --overlap-px: ${({ theme }) => theme.spacing.xl}px;
  padding-block-end: ${({ theme }) => theme.spacing.xl}px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  width: 100%;
  flex-grow: 1;
  flex-basis: auto;
  margin-bottom: calc(var(--overlap-px) * -0.5);
`;
export const MessageListContent = styled.div `
  height: 100%;
  width: 100%;
  position: relative;
`;
const GroupWidthStyling = css `
  animation: ${fadeIn} 0.3s ease-out;
  max-width: ${({ theme }) => theme.caps.normal}px;
  margin: 0 auto;
  width: 100%;
`;
export const MessageGroup = styled.article `
  ${GroupWidthStyling}
  & + & {
    margin-block-start: ${({ theme }) => theme.spacing.md}px;
  }
  &:first-child {
    margin-block-start: 0;
  }
  &:last-child {
    margin-block-end: 0;
  }
`;
export const MessageWrapper = styled.div `
  display: flex;
  align-items: flex-start;
  width: 100%;
  overflow: hidden;

  ${({ role }) => role === MessageRole.USER &&
    css `
      flex-direction: row-reverse;
      padding-left: ${({ theme }) => theme.spacing.xl}px;

      /* Responsive design: Mobile-first approach */
      @media (max-width: 576px) {
        padding-left: ${({ theme }) => theme.spacing.md}px;
      }
    `}
`;
export const MessageContent = styled.div `
  width: 100%;
  min-width: 0;
  max-width: 100%;

  ${({ role }) => role === MessageRole.USER &&
    css `
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      max-width: 70%;
      margin-block: ${({ theme }) => theme.spacing.md}px;
    `}
`;
export const StatusContainer = styled.div `
  display: flex;
  align-items: flex-end;
  gap: ${({ theme }) => theme.spacing.xs}px;
  ${createFontSizeCSS('body2')}
  color: ${({ theme }) => theme.colors.grey_2};
  line-height: 1;

  ${GroupWidthStyling}
`;
export const StreamingMessageText = styled.div `
  ${createFontSizeCSS('body2')}
  overflow-wrap: anywhere;

  > div {
    overflow-wrap: anywhere;
  }

  > div > * {
    animation: ${streamedChunkAppear} 0.5s ease-out both;
    transform-origin: top left;
  }

  @media (prefers-reduced-motion: reduce) {
    > div > * {
      animation: none;
    }
  }
`;
export const MessageBubble = styled.div `
  word-wrap: break-word;
  overflow-wrap: anywhere;
  word-break: break-word;
  min-width: 0;
  max-width: 100%;

  ${AssistantTypographyStyling}

  ${({ $role }) => {
    switch ($role) {
        case MessageRole.USER:
            return css `
          ${createFontSizeCSS('body2')}
          border-radius: ${({ theme }) => theme.border_radius.lg};

          background: ${({ theme }) => theme.colors.purple_5};
          border: 1px solid ${({ theme }) => theme.colors.purple_3};
          color: ${({ theme }) => theme.colors.grey_1};
          box-shadow: ${({ theme }) => theme.appearance.box_shadow};

          padding-inline: ${({ theme }) => theme.spacing.lg}px;
        `;
        case MessageRole.ASSISTANT:
            return css `
          background: transparent;
          color: ${({ theme }) => theme.colors.grey_1};
          text-align: left;
          ${createFontSizeCSS('body2')}
        `;
        case MessageRole.SYSTEM:
            return css `
          background: ${({ theme }) => theme.colors.yellow_4};
          color: ${({ theme }) => theme.colors.grey_2};
          border: 1px solid ${({ theme }) => theme.colors.yellow_3};
          ${createFontSizeCSS('body3')}
        `;
        default:
            return css `
          background: ${({ theme }) => theme.colors.beige_4};
          color: ${({ theme }) => theme.colors.black};
        `;
    }
}}

  ${({ $animateIn }) => $animateIn &&
    css `
      animation: ${messageAppear} 0.75s ease-out;
      transform-origin: top left;

      @media (prefers-reduced-motion: reduce) {
        animation: none;
      }
    `}
`;
export const ToolCallsContainer = styled.aside `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs}px;
`;
export const EmptyStateContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.grey_3};
  ${createFontSizeCSS('body2')}
`;
export const MessageListScrollContainer = styled.div `
  width: 100%;
  height: calc(100% + ${({ theme }) => theme.spacing.xxl}px);
  display: flex;
  flex-direction: column;

  padding-inline: ${({ theme }) => theme.spacing.xl}px;
  padding-block-start: ${({ theme }) => theme.spacing.xl}px;
  padding-block-end: calc(
    var(--overlap-px) + ${({ theme }) => theme.spacing.lg}px
  );

  scrollbar-gutter: stable both-edges;
  overflow-y: auto;
  overflow-x: hidden;
`;
export const MessageMetadata = styled.div `
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm}px;
  margin-bottom: ${({ theme }) => theme.spacing.sm}px;
  justify-content: flex-start;
`;
export const MessageIdentifiedGrants = styled.div `
  display: flex;
  flex-direction: column;
  border-radius: ${({ theme }) => theme.border_radius.sm};
  border: 1px solid ${({ theme }) => theme.colors.grey_4};
  background-color: ${({ theme }) => theme.colors.beige_2};

  .mig-content {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.sm}px;
    padding: ${({ theme }) => theme.spacing.md}px;
    max-height: 400px;
    overflow-y: auto;
  }
`;
